import { IOidcSettings } from '../../types';

const getSettings = async (): Promise<IOidcSettings> => {
  return fetch('/oidc.config.json').then((response) => response.json());
};

export const oidcSettings = await getSettings();
